import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import militaryAge18Webp from '@/assets/landing-military-calisthenics/age-18-2x.webp'
import militaryAge30Webp from '@/assets/landing-military-calisthenics/age-30-2x.webp'
import militaryAge40Webp from '@/assets/landing-military-calisthenics/age-40-2x.webp'
import militaryAge50Webp from '@/assets/landing-military-calisthenics/age-50-2x.webp'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingSubtitle', 'LandingAgeGrid'],

	components: {
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: 'MILITARY CALISTHENICS PLAN',
			uppercase: true,
			size: 'large',
			customStyles: {
				marginLeft: '1rem',
				marginRight: '1rem',
			},
		}),

		LandingSubtitle: (): LandingComponentsConfig['LandingSubtitle'] => ({
			uppercase: true,
			title: 'BASED ON YOUR AGE',
			customStyles: {
				fontWeight: 500,
			},
		}),

		LandingAgeGrid: (): LandingComponentsConfig['LandingAgeGrid'] => ({
			theme: 'military-gs',
			ageRanges: [
				{
					value: 18,
					analyticValue: '18-29',
					label: 'Age: 18-29',
					img: militaryAge18Webp,
				},
				{
					value: 30,
					analyticValue: '30-39',
					label: 'Age: 30-39',
					img: militaryAge30Webp,
				},
				{
					value: 40,
					analyticValue: '40-49',
					label: 'Age: 40–49',
					img: militaryAge40Webp,
				},
				{
					value: 50,
					analyticValue: '50-59',
					label: 'Age: 50+',
					img: militaryAge50Webp,
				},
			],
		}),
	},
}

export default schema
